import { render, staticRenderFns } from "./timeline-card.vue?vue&type=template&id=1a85492e&scoped=true&"
import script from "./timeline-card.vue?vue&type=script&lang=js&"
export * from "./timeline-card.vue?vue&type=script&lang=js&"
import style0 from "./timeline-card.vue?vue&type=style&index=0&id=1a85492e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85492e",
  null
  
)

component.options.__file = "timeline-card.vue"
export default component.exports